import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getUserAgentPrefix } from "@aws-sdk/util-endpoints";
import { HttpRequest } from "@smithy/protocol-http";
import { checkFeatures } from "./check-features";
import { SPACE, UA_ESCAPE_CHAR, UA_NAME_ESCAPE_REGEX, UA_NAME_SEPARATOR, UA_VALUE_ESCAPE_REGEX, USER_AGENT, X_AMZ_USER_AGENT } from "./constants";
import { encodeFeatures } from "./encode-features";
export var userAgentMiddleware = function userAgentMiddleware(options) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var _context$userAgent, _context$__smithy_con, _awsContext$__aws_sdk, _options$customUserAg;
        var request, headers, userAgent, defaultUserAgent, awsContext, customUserAgent, appId, prefix, sdkUserAgentValue, normalUAValue;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request = args.request;
                if (HttpRequest.isInstance(request)) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return", next(args));
              case 3:
                headers = request.headers;
                userAgent = (context === null || context === void 0 ? void 0 : (_context$userAgent = context.userAgent) === null || _context$userAgent === void 0 ? void 0 : _context$userAgent.map(escapeUserAgent)) || [];
                _context.next = 7;
                return options.defaultUserAgentProvider();
              case 7:
                defaultUserAgent = _context.sent.map(escapeUserAgent);
                _context.next = 10;
                return checkFeatures(context, options, args);
              case 10:
                awsContext = context;
                defaultUserAgent.push("m/".concat(encodeFeatures(Object.assign({}, (_context$__smithy_con = context.__smithy_context) === null || _context$__smithy_con === void 0 ? void 0 : _context$__smithy_con.features, (_awsContext$__aws_sdk = awsContext.__aws_sdk_context) === null || _awsContext$__aws_sdk === void 0 ? void 0 : _awsContext$__aws_sdk.features))));
                customUserAgent = (options === null || options === void 0 ? void 0 : (_options$customUserAg = options.customUserAgent) === null || _options$customUserAg === void 0 ? void 0 : _options$customUserAg.map(escapeUserAgent)) || [];
                _context.next = 15;
                return options.userAgentAppId();
              case 15:
                appId = _context.sent;
                if (appId) {
                  defaultUserAgent.push(escapeUserAgent(["app/".concat(appId)]));
                }
                prefix = getUserAgentPrefix();
                sdkUserAgentValue = (prefix ? [prefix] : []).concat([].concat(_toConsumableArray(defaultUserAgent), _toConsumableArray(userAgent), _toConsumableArray(customUserAgent))).join(SPACE);
                normalUAValue = [].concat(_toConsumableArray(defaultUserAgent.filter(function (section) {
                  return section.startsWith("aws-sdk-");
                })), _toConsumableArray(customUserAgent)).join(SPACE);
                if (options.runtime !== "browser") {
                  if (normalUAValue) {
                    headers[X_AMZ_USER_AGENT] = headers[X_AMZ_USER_AGENT] ? "".concat(headers[USER_AGENT], " ").concat(normalUAValue) : normalUAValue;
                  }
                  headers[USER_AGENT] = sdkUserAgentValue;
                } else {
                  headers[X_AMZ_USER_AGENT] = sdkUserAgentValue;
                }
                return _context.abrupt("return", next(_objectSpread(_objectSpread({}, args), {}, {
                  request: request
                })));
              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
var escapeUserAgent = function escapeUserAgent(userAgentPair) {
  var _userAgentPair$;
  var name = userAgentPair[0].split(UA_NAME_SEPARATOR).map(function (part) {
    return part.replace(UA_NAME_ESCAPE_REGEX, UA_ESCAPE_CHAR);
  }).join(UA_NAME_SEPARATOR);
  var version = (_userAgentPair$ = userAgentPair[1]) === null || _userAgentPair$ === void 0 ? void 0 : _userAgentPair$.replace(UA_VALUE_ESCAPE_REGEX, UA_ESCAPE_CHAR);
  var prefixSeparatorIndex = name.indexOf(UA_NAME_SEPARATOR);
  var prefix = name.substring(0, prefixSeparatorIndex);
  var uaName = name.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version].filter(function (item) {
    return item && item.length > 0;
  }).reduce(function (acc, item, index) {
    switch (index) {
      case 0:
        return item;
      case 1:
        return "".concat(acc, "/").concat(item);
      default:
        return "".concat(acc, "#").concat(item);
    }
  }, "");
};
export var getUserAgentMiddlewareOptions = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
export var getUserAgentPlugin = function getUserAgentPlugin(config) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
    }
  };
};